import React, { memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingFromTo({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const { asOfDate1, asOfDate2 } = reportSnapshot;
  const formattedAsOfDate1 = useFormatDateByLocale(asOfDate1);
  const formattedAsOfDate2 = useFormatDateByLocale(asOfDate2);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="calendar" />
        <GStyled.Text>From</GStyled.Text>
        <GStyled.Text fontWeight="medium">
        <GStyled.Text fontWeight="medium">{formattedAsOfDate1}</GStyled.Text>
        </GStyled.Text>
        <GStyled.Text>To</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate2}</GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
    </>
  );
}

export default memo(ReportSettingFromTo);
